import { netStatusEl } from '../ui/dom.js';

function setStatus(text) {
  if (netStatusEl) netStatusEl.textContent = text;
}

export { setStatus };
